import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[appScrollHeader]'
})
export class ScrollHeaderDirective implements OnInit{

  @Input() scrollTopAnimation: number = 0;
  @Output() headerAnimationUp = new EventEmitter<boolean>();

  private lastScrollTop: number = 0;
  private isMobileSize: boolean = false;

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    this.handleResize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.handleResize();
    if (!this.isMobileSize) {
      this.headerAnimationUp.emit(false);
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event): void {
    const currentScrollPos = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (this.isMobileSize) {
      if (currentScrollPos < this.scrollTopAnimation) {
        this.headerAnimationUp.emit(false);
      }

      if (currentScrollPos > this.scrollTopAnimation && currentScrollPos < this.lastScrollTop) {
        this.headerAnimationUp.emit(true);
      }

      if (currentScrollPos > this.scrollTopAnimation && currentScrollPos > this.lastScrollTop) {
        this.headerAnimationUp.emit(false);
      }

      this.lastScrollTop = currentScrollPos;
    }
  }

  private handleResize(): void {
    this.isMobileSize = window.innerWidth < 610;
    if (!this.isMobileSize) {
      this.headerAnimationUp.emit(false);
    }
  }

}
